import script from "./FirstPageAchievementList.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPageAchievementList.vue?vue&type=script&setup=true&lang=js"

import "./FirstPageAchievementList.vue?vue&type=style&index=0&id=9e20c180&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e20c180"]])

export default __exports__